/*
 * Form Messages
 *
 * This contains common text for forms
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  invalidEmailAddress: {
    id: 'app.components.UserForm.invalidEmailAddress',
    defaultMessage: 'Invalid email address',
  },
  invalidValue: {
    id: 'app.components.UserForm.invalidValue',
    defaultMessage: 'Invalid value',
  },
  required: {
    id: 'app.components.UserForm.required',
    defaultMessage: 'This field is required',
  },
  unequalPasswords: {
    id: 'app.components.UserForm.unequalPasswords',
    defaultMessage: 'The entered passwords are not matching',
  },
  save: {
    id: 'app.components.UserForm.save',
    defaultMessage: 'save',
  },
  minLength: {
    id: 'app.components.UserForm.minLength',
    defaultMessage: 'The entered value is too short',
  },
});
